import React from 'react'
import ShowtimePerformanceItem from './ShowtimePerformanceItem'
import getTranslationTime from '../functions/getTranslationTime'
import Translation from '../General/Translation'
import setMomentDateObjZero from '../functions/setMomentDateObjZero'
import getMomentNow from '../functions/getMomentNow'
import getDayKey from '../functions/getDayKey'


const ShowtimeDayItem = ({dayKey, items, translation, scrollToPosition, additionalScrollName, onClickItem, activeFilters, activeCinema}) => {
    const { timezone } = translation
    const today = setMomentDateObjZero(getMomentNow(timezone))
    const keyToday = getDayKey(today)
    const isToday = keyToday === dayKey
    
    return (
        <li className="showtimes-dayitem">
            <h5 className="showtime-day text-xlarge-bold">
                {isToday ? <Translation id="today" trans={translation}>Heute</Translation> : getTranslationTime('performanceDates', translation, dayKey)
                }
            </h5>
        <ul>
        {items.map((item, index) => (
            <ShowtimePerformanceItem
                key={index}
                index={index}
                activeCinema={activeCinema}
                activeFilters={activeFilters}
                item={item}
                translation={translation}
                scrollToPosition={scrollToPosition}
                additionalScrollName={additionalScrollName}
                onClickItem={onClickItem}
            />
        ))}
        </ul>
        <div className="showtimes-dayitem-line" />
    </li>
    )
}

export default ShowtimeDayItem

